import { Box } from '@mui/material';
import React from 'react';
export const Divider = ({ right, smallDevice }) => (React.createElement(Box, { sx: {
        width: 0,
        height: 32,
        borderLeftWidth: 1,
        borderLeftStyle: 'solid',
        borderLeftColor: 'grey.700',
        ml: right ? (smallDevice ? 1 : 1) : 0,
        mr: right ? 0 : smallDevice ? 1 : 1,
    } }));
